import * as services from 'services/template.services';
import * as types from 'constants/templatesActionTypes';
import { showAlert } from 'actions/alert.actions';
import { ALERT_ERROR_TYPE } from 'constants/alertTypes';
import { ERROR_SAVE } from 'constants/MensajesGenerales';

export const getPlantillas = () => async (dispatch) => {
  dispatch({ type: types.GET_LIST_TEMPLATES_LOADING });
  try {
    const { data } = await services.fetchTemplates();

    dispatch({ type: types.GET_LIST_TEMPLATES_SUCCESS, payload: data.plantillas });
    return { success: true };
  } catch (error) {
    dispatch({ type: types.GET_LIST_TEMPLATES_FAILURE, error });
    return { success: false };
  }
};

export const getParametrosPlantillas = (payload) => async (dispatch) => {
  dispatch({ type: types.GET_PARAMETERS_TEMPLATE_LOADING });
  try {
    const { data } = await services.fetchParametersTemplate(payload);

    dispatch({ type: types.GET_PARAMETERS_TEMPLATE_SUCCESS, payload: data.plantilla });
    return { success: true };
  } catch (error) {
    console.log(error);
    dispatch({ type: types.GET_PARAMETERS_TEMPLATE_FAILURE, error });
    return { success: false };
  }
};

export const guardarParametroPlantilla = (payload) => async (dispatch) => {
  dispatch({ type: types.SAVE_PARAMETERS_TEMPLATE_LOADING });
  try {
    const { data } = await services.saveParametersTemplate(payload);
    console.log(data.plantilla.notSynced[0].id ? 'tieene' : 'notiene');
    if (data.plantilla.notSynced[0].id) {
      const errorMessage = ERROR_SAVE;
      dispatch({
        type: types.SAVE_PARAMETERS_TEMPLATE_FAILURE,
        error: { message: errorMessage }
      });
      dispatch(showAlert(errorMessage, ALERT_ERROR_TYPE));
      return { success: false };
    }
    dispatch({ type: types.SAVE_PARAMETERS_TEMPLATE_SUCCESS, payload: data });
    return { success: true };
  } catch (error) {
    dispatch({ type: types.SAVE_PARAMETERS_TEMPLATE_FAILURE, error });
    return { success: false };
  }
};
